// MainNav1.tsx
import React, { FC, useEffect, useRef, useState } from "react";
import Logo from "shared/Logo/Logo";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import SearchInput from "./SearchInput";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import GetAppDropdown from "./GetAppDropdown";
import { useLocation } from "react-router-dom";

export interface MainNav1Props {
  className?: string;
}

const MainNav1: FC<MainNav1Props> = ({ className = "" }) => {
  const { logout, isAuthenticated, isLoading, loginWithRedirect, user } =
    useAuth0();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const documentRef = useRef<HTMLElement | null>(document.documentElement);

  let location = useLocation();

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        menuRef.current &&
        documentRef.current &&
        !menuRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    documentRef.current!.addEventListener("mousedown", handleOutsideClick);

    return () => {
      documentRef.current!.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleLogout = () => {
    setIsOpen(false);
    logout();
  };

  return (
    <div className={`nc-MainNav1 relative z-10 ${className}`}>
      <div className={`px-4 py-4 lg:py-5 lg:px-8 relative flex justify-between items-center`}>
        <div className="flex-none md:flex justify-start items-center">
          <Logo className="" />
        </div>

        {location.pathname !== "/" && (
          <>
            <div className="flex-1 md:flex justify-center items-center mx-5 hidden">
              <SearchInput
                type="Search by street name"
                className={"w-1/3"}
              />
            </div>
            <div className="ml-3 flex md:hidden justify-center items-center w-1/2 md:w-full">
              <SearchInput
                type="Street name"
                className={`${!isAuthenticated ? "w-3/5" : ""}`}
              />
            </div>
          </>
        )}
        <div
        >
          <div className="md:flex items-center">
            <div className="hidden md:flex">
              <Link to={"/cosigner"}>Cosigner</Link>
            </div>

            {/* <div className=""><Link to={"/contact"}>contact</Link></div> */}

            {/* <GetAppDropdown /> */}
            {!isAuthenticated && !isLoading && (
              <ButtonPrimary
                key="login"
                onClick={async () => {
                  await loginWithRedirect();
                }}
                className="hidden md:block md:ml-5"
              >
                Login
              </ButtonPrimary>
            )}
            <div className="flex justify-center items-center">
              {isAuthenticated && !isLoading && (
                <div className="md:ml-5" ref={menuRef}>
                  <button
                    onClick={handleToggle}
                    className="flex items-center focus:outline-none"
                  >
                    <img
                      className="h-11 w-11 rounded-full object-cover"
                      src={user!.picture}
                      alt={user!.name}
                    />
                  </button>
                  {isOpen && (
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1">
                      {/* <button className="w-full px-6 py-2 text-left text-gray-800 hover:bg-gray-100">
                        Profile
                      </button> */}
                      <button
                        onClick={handleLogout}
                        className="w-full px-6 py-2 text-left text-gray-800 hover:bg-gray-100"
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNav1;
